import React from 'react';

const StepsFooter = ({ hasPrevious, handlePrevStep, lastStep, activeStep, t, isSubmitting, checkTC, checkFD }) => {
  return (
    <div className="row justify-content-around mb-4">
      {hasPrevious() && (
        <button type="button" className="btn btn-ghost mt-3 text-uppercase" disabled={isSubmitting} onClick={handlePrevStep}>
          {t('buttonBackSpanish')}
        </button>
      )}
      <button type="submit" className="btn btn-dark mt-3 text-uppercase" disabled={lastStep !== activeStep ? false : !(checkTC && checkFD)}>
        {lastStep === activeStep ? t('buttonSubmit') : t('buttonNextSpanish')}
      </button>
    </div>
  );
};

export default StepsFooter;
